import React, { useEffect, useRef, useState } from "react";
import { renderSteps } from "./RenderSteps";
import Footer from "./Footer";
import { OnboardingForms, } from "../../typings/onboarding";
import { DefaultOnboardingStepsSequence, OnboardingStepsEnums, SSN_LENGTH } from "../../constants/onboarding";
import { DocumentEntityTypesEnum, DocumentService, DocumentTypesEnum, LeaseAgreementService, LeaseAgreementStatusTypesEnum, LeaseApplicationCreditCheckVM, LeaseApplicationReviewVM, LeaseApplicationService, LeaseApplicationStatusTypesEnum, LoginService, OnboardingService, QuestionTypeEnum, RentPayTypesEnum, TemplateService, TenantService, TenantVM, UnitService, } from "@propertelligent/client-api";
import "./tenantOnboard.css"
import apiHelper from "../../utils/apiHelper";
import BoardingReview from "./RenderSteps/BoardingReview";
import { useError } from "../../utils/context/ErrorContext";
import { useGeneratePdfContext } from "../../utils/context/GeneratePdfContext";
import ShowLeaseAgreement from "../tenants/LeaseAgreement/ShowLeaseAgreement";
import FullLoginScreen from "./component/FullLoginScreen";
import GoodbyePage from "../common/GoodbyePage/GoodbyePage";
import { checkEmptyFieldsFunc, handleDownloadPdf, handleGenerateAndUploadPdf } from "../../utils/validateHelper";
import { utcDateFormat } from "../../utils/helper";
import { GetImages } from "../../utils/GetImages";
import { useOnboardingContext } from "../../utils/context/OnboardingContext";
import { NotificationType, PubSub, TopicsEnum } from "../../utils/pubsub";
import UnitCardItem from "../../newComponents/unit/UnitCardItem";
import OrganizationNameHeader from "../common/OrganizationNameHeader/OrganizationNameHeader";
import StepOne from "./RenderSteps/StepOne";
import SectionHeader from "./Header/SectionHeader";
import StepProgress from "./component/StepProgress/StepProgress";
import { useDispatch, useSelector } from "react-redux";
import StatusHeader from "./component/StatusHeader/StatusHeader";
import CommonConfirmation from "../common/CommonConfirmation";
import { CustomInputTextArea } from "../common/formControls";
import { useNavigate } from "react-router";
import { URLS } from "../../constants/constants";
import { ConfirmationPopup } from "../../newComponents/confirmation-popup/confirmation-popup-demo";
import { TextCss } from "../GlobalCss/TextCss";
import ActionMenu from "../../newComponents/actionMenus/action-menu";
import LoaderOverlay from "../common/LoaderOverlay";
import SimpleSpinner from "../loader";
import { useTheme } from "../../utils/context/ThemeContext";
import { Moon, Sun, Menu } from "lucide-react";

// Shared copy for the three "nothing to resume, show a goodbye screen instead of the onboarding
// wizard" cases -- see the goodbyeReason/movedOut logic below for how each is detected.
// accountDeleted and movedOut are genuine farewells (GoodbyePage's default "👋 Thank You!" framing
// fits); noActiveApplication is an informational empty state, not a farewell, so it overrides the
// icon/title/animation and skips `subtext` entirely -- GoodbyePage's own fixed contact line already
// says "contact your property manager", so repeating that in `subtext` was showing it twice.
const GOODBYE_SCREEN_COPY: Record<"accountDeleted" | "noActiveApplication" | "movedOut", {
  message: string;
  subtext?: string;
  icon?: string;
  title?: string;
  animateIcon?: boolean;
}> = {
  accountDeleted: {
    message: "Your account is no longer active.",
    subtext: "This tenant record has been removed by your property manager.",
  },
  noActiveApplication: {
    icon: "📋",
    title: "No Active Application",
    animateIcon: false,
    message: "You don't currently have an active lease application.",
  },
  movedOut: {
    message: "It has been a pleasure having you. Thank you for staying with us!",
    subtext: "Your lease has ended.",
  },
};

// UserBaseBM / UserBaseVM echo fields that round-trip on save-then-refetch (Back → Next).
// Null leaves (esp. whatsAppOptInAt) make checkEmptyFieldsFunc fail with no visible UI field.
// Bare keys are for array sections (EmploymentHistory / References); dotted keys for nested objects.
export const userBaseEchoSkipKeys = [
  "whatsAppOptIn",
  "whatsAppOptInAt",
  "hasPassword",
  "fullName",
  "initials",
];

// Exported so tests import this exact map instead of hand-duplicating it.
export const skipFieldMap = {
  RentIncomeCheck: [
    "employerDetails.endDate",
    ...userBaseEchoSkipKeys.map((k) => `employerDetails.${k}`),
    ...userBaseEchoSkipKeys.map((k) => `assistedDetails.${k}`),
  ],
  // List<LeaseApplicationEmployerBM> / List<LeaseApplicationReferenceBM> — array walk
  // in checkEmptyFieldsFunc matches bare keys (see validateHelper array skip).
  EmploymentHistory: [...userBaseEchoSkipKeys],
  References: [...userBaseEchoSkipKeys],
};

const TenantOnboard: React.FC<any> = () => {
  const [leaseApplication, setLeaseApplication] = useState<any>()
  const navigate = useNavigate()
  const params = new URLSearchParams(location.search);
  const leaseApplicationToken = params.get("la");
  const tenantData = sessionStorage.getItem("tenantInfo");
  const tenantObject = JSON.parse(tenantData);
  const [template, setTemplate] = useState<any>()
  const [formData, setFormData] = useState<OnboardingForms>({
    BasicDetails: { firstName: "", lastName: "", email: "", phoneNumber: "", password: "", confirmPassword: "" },
    CurrentAddress: {
      streetAddress: "",
      city: "",
      state: "",
      zip: "",
      unitNumber: "",
      moveOutDate: "",
      moveOutReasonTypeId: undefined
    },
    CreditCheck: {
      taxIdNumber: "",
      dateOfBirth: "",
      consentToRunCheck: true
    } as LeaseApplicationCreditCheckVM,
    RentIncomeCheck: { rentPayTypeId: RentPayTypesEnum.Income },
    EmploymentHistory: [],
    References: [],
    Questionnaires: [],
    // ApplicationFees: DefaultFeeFormData,
    Signature: { fullName: "", signedDateTime: "" },
  });
  const [withdraw, setWithdraw] = useState(false)
  const [leaseApplicationreview, setleaseApplicationreview] = useState<LeaseApplicationReviewVM>(
    { leaseApplicationStatusTypeId: LeaseApplicationStatusTypesEnum.Withdrawn, internalNotes: "", tenantNotes: "" })
  const [logout, setlogout] = useState(false)
const [showSignAgreeConfirm, setShowSignAgreeConfirm] = useState(false);
  const [unit, setUnit] = useState()
  const [steps, setSteps] = useState(DefaultOnboardingStepsSequence);
  const [preStepIndex, setpreStepIndex] = useState(0);
 
  //  const [currentStepIndex, setCurrentStepIndex] = useState(tenantData ? 1 : 0);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  
  const [loading, setLoading] = useState(false);
  const [isInitialDataLoading, setIsInitialDataLoading] = useState(true);
  const [showApp, setShowApp] = useState(false);
  const [isReLogin, setIsReLogin] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [stepFivePart2, setStepFivePart2] = useState(false);
  const [leaseApplicationid, setLeaseApplicationId] = useState(null);
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError();
  const [docsArr, setDocsArr] = useState([]);
  const [OrgDetail, setOrgDetail] = useState<any>()
  const [codeExpired, setCodeExpired] = useState<Boolean>(false)
  // Set by getTenantsData (404 -- the Tenant row no longer exists) or fetchData (no leaseApplicationId
  // -- e.g. an org admin "deleted" a prospect via handleDeleteTanent, which only deletes the
  // LeaseApplication, not the Tenant). null means neither has fired; see GOODBYE_SCREEN_COPY below
  // for the third case (movedOut), which is derived rather than set here.
  const [goodbyeReason, setGoodbyeReason] = useState<"accountDeleted" | "noActiveApplication" | null>(null)
  const { setOrgDetails, setSubHeaderName } = useGeneratePdfContext();
  const [userData, setUserData] = useState<any>(null)
  const { currentLeaseInfo, currentLeaseApplicationInfo } = userData || {};
  const [tenantId, setTenantId] = useState<Number>()
  const [signLeaseAgreement, setSignLeaseAgreement] = useState(false)
  const [isPrint, setISPrint] = useState(false)
  const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  const [isDownloadingApplication, setIsDownloadingApplication] = useState(false);
  const contentRef = useRef()
  const { theme, toggleTheme } = useTheme();
  const dispatch = useDispatch()
  const [postLeaseAgreement, setPostLeaseAgreement] = useState<any>({
    tenantId: tenantId, unitId: currentLeaseApplicationInfo?.unit?.id,
    templateId: currentLeaseInfo?.templateId, dataAttributes: {},
    leaseAgreementId: Number,
    tenantSignature: { fullName: "", signedDateTime: "" },
    landlordSignature: { fullName: "", signedDateTime: "", }
  })

  const { isSignatureConfirm, countryCode } = useOnboardingContext();
  const [isClickPrevious, setIsClickPrevious] = useState(false)
  const [status, setStatus] = useState(""); // you can get this from API
  useEffect(() => {
    if (leaseApplication?.leaseApplicationStatusTypeId === LeaseApplicationStatusTypesEnum.PaymentPending) {
      setStatus("feeNotSettled")
    } else if (leaseApplication?.leaseApplicationStatusTypeId === LeaseApplicationStatusTypesEnum.Submitted
      ||  leaseApplication?.leaseApplicationStatusTypeId === LeaseApplicationStatusTypesEnum.InReview 
      
    ) {
      setStatus("submitted")
    } else if (leaseApplication?.leaseApplicationStatusTypeId === LeaseApplicationStatusTypesEnum.Withdrawn) {
      setStatus("withdraw")
    } else if (leaseApplication?.leaseApplicationStatusTypeId === LeaseApplicationStatusTypesEnum.Closed) {
      setStatus("close")
    } else if (leaseApplication?.leaseApplicationStatusTypeId === LeaseApplicationStatusTypesEnum.Rejected) {
      setStatus("Reject")
    }
    // else if (leaseApplication?.leaseApplicationStatusTypeId === LeaseApplicationStatusTypesEnum.Approved) {
    //   setStatus("review")
    // } 
    else if (leaseApplication?.leaseApplicationStatusTypeId === LeaseApplicationStatusTypesEnum.InProgress
    ) {
      setStatus("inprogress")
    } else if (leaseApplication?.leaseAgreementStatusTypeId == LeaseAgreementStatusTypesEnum.PendingTenantSignature) {
      setStatus("tenantSignaturePending")
    }
     else if (leaseApplication?.leaseAgreementStatusTypeId == LeaseAgreementStatusTypesEnum.PendingPayment) {
      setStatus("agreementPaymentPending")
    }
    else if (leaseApplication?.leaseAgreementStatusTypeId == LeaseAgreementStatusTypesEnum.PendingLandlordSignature) {
      setStatus("landlordSignaturePending")
    } else if (leaseApplication?.leaseAgreementStatusTypeId == LeaseAgreementStatusTypesEnum.Signed) {
      setStatus("signed")
    }

  }, [leaseApplication?.leaseApplicationStatusTypeId, leaseApplication?.leaseAgreementStatusTypeId])
  const handleActionClick = (actionLabel) => {
    if (actionLabel === "Sign Application" || actionLabel === "Sign Agreement") {
      const element = document.getElementById("signature-section");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
      // setStatus("submitted"); 
    } else if (actionLabel == "Download Application") {
      const downloadPdf = async () => {
        setIsDownloadingApplication(true);
        try {
          await handleDownloadPdf(setISPrint, contentRef, `LeaseApplication-${userData?.firstName} ${userData?.lastName}.pdf`);
        } finally {
          setIsDownloadingApplication(false);
        }
      };
      downloadPdf();
    } else if (actionLabel == "withdraw") {
      setWithdraw(true)
    }
  };
 
  const { } = useSelector((state) => state)

  const setdata = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      Signature: prevFormData
        ?.Signature ? prevFormData?.Signature : { fullName: "", signedDateTime: "" },
    }));
  }

  // useEffect(() => {
  //   if (steps[currentStepIndex] == OnboardingStepsEnums.Signature) { setdata() }
  // }, [formData?.Signature, steps[currentStepIndex] == OnboardingStepsEnums.Signature]);
  useEffect(() => {
    
  if (steps[currentStepIndex] === OnboardingStepsEnums.Signature) {
      setdata();
  }
}, [currentStepIndex]);

  const getTenantsData = async () => {
    if (tenantObject !== null) {
      const { tenantId } = tenantObject;
      setTenantId(tenantId)
      if (tenantId) {
        const tenantsResponse = await apiHelper(TenantService.getApiTenant1, { showNotification: false }, Number(tenantId));
        // A 404 means the Tenant row is gone (deleted by the org admin) but this session's JWT/
        // sessionStorage was cached from before the delete -- show the goodbye screen instead of
        // silently continuing with no data (which renders a broken onboarding wizard).
        if (tenantsResponse?.statusCode === 404) {
          setGoodbyeReason("accountDeleted");
          return;
        }
        setUserData(tenantsResponse?.data?.success)
      }
    }
  };

  const fetchData = async () => {
    if (tenantObject) {
      const { leaseApplicationId } = tenantObject;
      if (!leaseApplicationId) {
        // Tenant row exists and login succeeded, but there's no lease application to resume --
        // e.g. their prospect application was withdrawn/deleted (handleDeleteTanent only calls
        // LeaseApplicationService.deleteApiLeaseApplication, it does not delete the Tenant row).
        // Without this, template/steps are silently never set and the render falls through to the
        // "resume onboarding" wizard branch anyway, producing a blank/broken UI.
        setGoodbyeReason("noActiveApplication");
        return;
      }
      if (leaseApplicationId) {
        setLeaseApplicationId(leaseApplicationId);
        try {
          await Promise.all([
            apiHelper(LeaseApplicationService.getApiLeaseApplicationOrganizationHeaderInfo, { showNotification: false }, leaseApplicationId).then((res) => {
              setOrgDetail(res?.data?.success)
              setOrgDetails(res?.data?.success)
              setSubHeaderName("Tenant Onboarding")
            }).catch((error) => { }),
            apiHelper(LeaseApplicationService.getApiLeaseApplication1, { showNotification: false }, leaseApplicationId).then(async (response: any) => {
              const leaseAppData = response?.data?.success;
              setLeaseApplication(leaseAppData);
              setUnit(leaseAppData?.unit);
              const getValue = leaseAppData?.dataSections;

              setFormData(prev => ({
                ...prev,
                // BasicDetails: { firstName: leaseAppData?.tenant?.firstName, lastName: leaseAppData?.tenant?.lastName, email: leaseAppData?.tenant?.email, phoneNumber: leaseAppData?.tenant?.phoneNumber, password: leaseAppData?.tenant?.password, confirmPassword: leaseAppData?.tenant?.password },
                CreditCheck: JSON.parse(getValue?.CreditCheck ? getValue?.CreditCheck : null),
                CurrentAddress: getValue?.CurrentAddress ? JSON.parse(getValue?.CurrentAddress) : null,
                EmploymentHistory: getValue?.EmploymentHistory ? JSON.parse(getValue?.EmploymentHistory) : null,
                Questionnaires: JSON.parse(getValue?.Questionnaires ? getValue?.Questionnaires : null),
                References: JSON.parse(getValue?.References ? getValue?.References : null),
                RentIncomeCheck: getValue?.RentIncomeCheck ? JSON.parse(getValue?.RentIncomeCheck) : null,
                Signature: JSON.parse(getValue?.Signature ? getValue?.Signature : null),
                ApplicationFees: JSON.parse(getValue?.ApplicationFees ? getValue?.ApplicationFees : null),
              }));

              await Promise.all([
                apiHelper(UnitService.getApiUnit1, { showNotification: false }, leaseAppData.unitId)
                  .then(res => setUnit(res?.data?.success))
                  .catch(err => console.error("Error fetching property:", err)),
                apiHelper(TemplateService.getApiTemplate, { showNotification: false }, leaseAppData?.templateId)
                  .then((template) => {
                    const templateData = template?.data?.success;
                    setTemplate(templateData);

                    if (templateData?.leaseApplicationTemplateSections) {
                      const stepsReceived = Array.from(new Set([
                        ...Object.keys(templateData.leaseApplicationTemplateSections),
                        OnboardingStepsEnums.Signature,
                      ]));
                      const filteredSteps = steps.filter((itm) => stepsReceived.includes(itm));
                      setSteps(filteredSteps);
                      setIsReLogin(true);
                    }
                  }).catch((error) => { })
              ]);
            }).catch((tenantErr: any) => { })
          ]);
        } catch (error) {
          console.error(error);
        }
      }
    } else if (leaseApplicationToken) {
      try {
        await Promise.all([
          apiHelper(OnboardingService.getApiOnboardingTenantOrganizationHeaderInfo, { showNotification: false },
            leaseApplicationToken).then((res) => {
              setOrgDetail(res?.data?.success)
              if (res?.data?.success == null) { setCodeExpired(true) }
            }).catch((error) => { }),
          apiHelper(OnboardingService.getApiOnboardingTenantTenantInfo, { showNotification: false },
            leaseApplicationToken).then((res) => {
              setFormData(prev => ({
                ...prev,
                BasicDetails: {
                  firstName: res?.data?.success?.firstName,
                  lastName: res?.data?.success?.lastName, email: res?.data?.success?.email,
                  phoneNumber: res?.data?.success?.formatted?.PhoneNumber,
                  password: "", confirmPassword: ""
                },
              }));
            }).catch((error) => { }),
          apiHelper(OnboardingService.getApiOnboardingTenantUnitInfo, { showNotification: false },
            leaseApplicationToken).then((res) => {
              setUnit(res?.data?.success)
            }).catch((error) => { })
        ]);
      } catch (error) {
        console.error(error);
      }
    } else {
      setCodeExpired(true)
    }
  }

  useEffect(() => {
    const loadInitialData = async () => {
      setIsInitialDataLoading(true);
      if (tenantData) {
        await Promise.all([getTenantsData(), fetchData()]);
      } else {
        await fetchData();
      }
      setIsInitialDataLoading(false);
    };
    loadInitialData();
  }, [tenantData]); // run when tenantData is available, removed leaseApplicationid to prevent loops

  useEffect(() => {
    if (!userData) return;

    setPostLeaseAgreement((prev) => ({
      ...prev,
      tenantId: userData.id,
      unitId: userData.currentLeaseApplicationInfo?.unit?.id ?? null,
      templateId: userData.currentLeaseInfo?.templateId ?? null,
      dataAttributes: userData.currentLeaseInfo?.dataAttributes ?? {},
    }));
  }, [userData]);

  const goNextStep = () => {
    if (isEdit) {
      setCurrentStepIndex(preStepIndex);
      setIsEdit(false)
      return;
    } else { setCurrentStepIndex((step) => step + 1); }
  };

  const goPrevStep = () => {
    if (isReLogin && currentStepIndex <= 0) { return; }
    clearErrors();
    setCurrentStepIndex((step) => step - 1);
    setIsClickPrevious(true);
  };

  const isEditClick = (index) => {
    setIsEdit(true); setCurrentStepIndex(index);
  };

  const uploadImage = async (doc) => {
    if (doc?.id) { return doc; }

    const docData = {
      EntityTypeId: doc.EntityTypeId,
      EntityId: doc.EntityId,
      DocumentTypeId: doc.documentTypeId,
      IsMain: doc.IsMain,
      FileName: doc.fileName,
      Document: doc.Document,
    };

    const result = await apiHelper(
      DocumentService.postApiDocument,
      {
        showNotification: true,
        successMessage: "Document Uploaded Successfully",
        failureMessage: "Unable to upload document",
      },
      docData
    );
    const uploadedDoc = result?.data?.success;
    return uploadedDoc?.id ? { ...doc, id: uploadedDoc.id } : null;
  };
  const uploadAllImages = async (docArray): Promise<boolean> => {
    let allOk = true;
    const updatedDocs = [];
    for (let i = 0; i < docArray.length; i++) {
      const uploadedDoc = await uploadImage(docArray[i]);
      if (!uploadedDoc) {
        allOk = false;
        updatedDocs.push(docArray[i]);
      } else {
        updatedDocs.push(uploadedDoc);
      }
    }
    setDocsArr((prev) =>
      prev.map((d) => {
        const idx = docArray.indexOf(d);
        return idx >= 0 ? updatedDocs[idx] : d;
      })
    );
    return allOk;
  };
  const goToApplicationView = () => {
    setCurrentStepIndex(null); setShowApp(true)
  };


  const handleUploadDocument = async (pdfBlob) => {
    const pdfFile = new File([pdfBlob], 'Lease_Application.pdf', { type: 'application/pdf' });
    const imgData = {
      EntityId: Number(tenantId),
      EntityTypeId: DocumentEntityTypesEnum.Tenant,
      DocumentTypeId: DocumentTypesEnum.LeaseApplication,
      IsMain: false,
      Document: pdfFile,
      FileName: 'Lease_Application.pdf',
    };
    await apiHelper(
      DocumentService.postApiDocument,
      { showNotification: false },
      imgData
    ).then((res) => { }).catch((err) => { })
  }

  const handleSubmit = async () => {
    // e.preventDefault()
    const currentStep = steps[currentStepIndex];
    let successMessage = isEdit ? `${currentStep.replace(/([a-z])([A-Z])/g, "$1 $2")} Update Successfully` : `${currentStep.replace(/([a-z])([A-Z])/g, "$1 $2")} Added Successfully`
    try {
      let cantGoNext = false;
      let data: any = formData[currentStep] || {}
       let docError = false;
       const skipFields = skipFieldMap[currentStep] || [];
      if (currentStep === OnboardingStepsEnums.RentIncomeCheck) {
        data = { ...data };

        if (data.rentPayTypeId === RentPayTypesEnum.Income) {
          delete data.assistedDetails;
          delete data.assistedAmount;
        } else if (data.rentPayTypeId === RentPayTypesEnum.Assisted) {
          delete data.employerDetails;
          delete data.employmentIncome;
        }


 const emptyFieldError = checkEmptyFieldsFunc(
    data,
    clearErrors,
    errors,
    errorMessages,
    setErrors,
    setErrorMessages,
    skipFields,
    countryCode
  )
     
  if (data.rentPayTypeId === RentPayTypesEnum.Income || data.rentPayTypeId === RentPayTypesEnum.Both) {
     let hasIncomeDoc = docsArr.some((doc) => doc.documentTypeId === DocumentTypesEnum.IncomeVerification);
        if (!hasIncomeDoc) {
      setErrors((prev) => ({ ...prev, incomeVerDoc: true }));
      setErrorMessages((prev) => ({
        ...prev,
        incomeVerDoc: "Income verification document is required",
      }));
       docError = true;
    }
  }

  if (data.rentPayTypeId === RentPayTypesEnum.Assisted || data.rentPayTypeId === RentPayTypesEnum.Both) {
    
      let hasAssistDoc = docsArr.some((doc) => doc.documentTypeId === DocumentTypesEnum.AssistanceVerification);
  if (!hasAssistDoc) {
      setErrors((prev) => ({ ...prev, assistVerDoc: true }));
      setErrorMessages((prev) => ({
        ...prev,
        assistVerDoc: "Assistance verification document is required",
      }));
     docError = true;

    }
  }
  if (docError || emptyFieldError) {
    return;
  }

  setLoading(true);
  const uploadOk = await uploadAllImages(docsArr);
  if (!uploadOk) {
    setLoading(false);
    return;
  }
 }

      const apiFunctionMapping = {
        CurrentAddress: LeaseApplicationService.putApiLeaseApplicationCurrentAddress,
        RentIncomeCheck: LeaseApplicationService.putApiLeaseApplicationRentIncome,
        CreditCheck: LeaseApplicationService.putApiLeaseApplicationCreditCheck,
        EmploymentHistory: LeaseApplicationService.putApiLeaseApplicationEmpploymentHistory,
        References: LeaseApplicationService.putApiLeaseApplicationReferences,
        Questionnaires: LeaseApplicationService.putApiLeaseApplicationQuestionaires,
        Signature: LeaseApplicationService.putApiLeaseApplicationTenantSignature,
      };
      
      const apiFunction = apiFunctionMapping[currentStep];

      if (currentStep === OnboardingStepsEnums.CreditCheck) {
        const taxId = data?.taxIdNumber ?? "";
        // Only fire this length-specific message once something has actually been typed --
        // a genuinely blank field should still fall through to checkEmptyFieldsFunc's own
        // "required" messaging below, not this one.
        if (taxId.length > 0 && taxId.length !== SSN_LENGTH) {
          setErrors((prev) => ({ ...prev, taxIdNumber: true }));
          setErrorMessages((prev) => ({
            ...prev,
            taxIdNumber: `Social Security Number must be exactly ${SSN_LENGTH} digits`,
          }));
          setLoading(false);
          return;
        }
      }
      if (currentStep === OnboardingStepsEnums.Signature) {
        let hasError = false;
        if (!data?.fullName?.trim()) {
          hasError = true;
          setErrors((prev) => ({ ...prev, fullName: true }));
          setErrorMessages((prev) => ({
            ...prev,
            fullName: "Full Name is required"
          }));
        }

        if (!isSignatureConfirm) {
          hasError = true;
          setErrors((prev) => ({ ...prev, isSignatureConfirm: true }));
          setErrorMessages((prev) => ({
            ...prev,
            isSignatureConfirm: "Please confirm the information"
          }));
        }

        if (hasError) { setLoading(false); return; }
      }
      if (checkEmptyFieldsFunc(data, clearErrors, errors,
        errorMessages, setErrors, setErrorMessages, skipFields,
        countryCode)) {
        cantGoNext = true;
        if (currentStep === OnboardingStepsEnums.Signature && !isSignatureConfirm) {
          setErrors((prev) => ({ ...prev, isSignatureConfirm: true }));
          setErrorMessages((prev) => ({ ...prev, isSignatureConfirm: "Please confirm the information" }));
        }
        setLoading(false);
        return
      } else {
        if (apiFunction == apiFunctionMapping.Signature) {
          if (!isSignatureConfirm) {
            setErrors((prev) => ({ ...prev, isSignatureConfirm: true }));
            setErrorMessages((prev) => ({ ...prev, isSignatureConfirm: "Please confirm the information" }));
            setLoading(false);
            return;
          }
          data = { ...data, signedDateTime: data.signedDateTime ? utcDateFormat(data.signedDateTime) : new Date().toISOString() }
        }
        setLoading(true);
        await apiHelper(apiFunction, {
          showNotification: true, successMessage: successMessage, failureMessage: `${currentStep} Unable to Add`
        }, Number(leaseApplicationid), data).then(async (res) => {
          if (res?.data?.success) {
            if (currentStep === OnboardingStepsEnums.Signature) {
              setIsProcessingSignature(true);
              // Sync local state with successful submission data to ensure signature is visible
              setFormData(prev => ({ ...prev, Signature: data }));

              await new Promise(resolve => setTimeout(resolve, 0));
              
              // Run PDF in background
              handleGenerateAndUploadPdf(setISPrint, contentRef, async (blob) => {
                const file = new File([blob], `LeaseApplication-${currentLeaseInfo?.addressLine1 || "Signed"}.pdf`, { type: "application/pdf" });
                const uploadData = {
                  EntityTypeId: DocumentEntityTypesEnum.Tenant,
                  EntityId: Number(tenantId),
                  DocumentTypeId: DocumentTypesEnum.LeaseApplication,
                  IsMain: false,
                  FileName: file.name,
                  Document: file,
                };
                await apiHelper(DocumentService.postApiDocument, { showNotification: false }, uploadData);
              }).finally(() => {
                PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null);
                fetchData();                
                setIsProcessingSignature(false);
                goToApplicationView();       
              });
            } else {
              goNextStep();
              fetchData();
            }
          }
          return true
        }).catch((err) => { });
      }

      setLoading(false);
      // fetchData()
    } catch (error: any) { setLoading(false) }
  };

  useEffect(() => {
    const relevantStatuses = [
      LeaseApplicationStatusTypesEnum.Submitted,
      LeaseApplicationStatusTypesEnum.Approved,
      LeaseApplicationStatusTypesEnum.InReview,
      LeaseApplicationStatusTypesEnum.Rejected,
      LeaseApplicationStatusTypesEnum.Closed,
      LeaseApplicationStatusTypesEnum.Withdrawn,
      LeaseApplicationStatusTypesEnum.PaymentPending,
    ];
     if (isReLogin && relevantStatuses.includes(leaseApplication?.leaseApplicationStatusTypeId)) { goToApplicationView() }
  }, [isReLogin, leaseApplication?.leaseApplicationStatusTypeId]);

  useEffect(() => {
    if (steps[currentStepIndex] == OnboardingStepsEnums.Signature) {
      setpreStepIndex(currentStepIndex)
    }
  }, [currentStepIndex])

  const SignLeaseAgreement = () => {
    let leaseData = { fullName: postLeaseAgreement?.tenantSignature?.fullName, signedDateTime: new Date().toISOString() }
    if (checkEmptyFieldsFunc(leaseData, clearErrors, errors, errorMessages, setErrors, setErrorMessages,
      //  steps[currentStepIndex]
    )) {
      setErrors({ ...errors, fullName: true })
      setErrorMessages({ ...errorMessages, fullName: "Full Name is required" })
      return
    } 
    else {
        apiHelper(LeaseAgreementService.putApiLeaseAgreementTenantSignature, {
          showNotification: true, successMessage: "Lease Agreement Sign successfully",
          failureMessage: "Unable to Sign Lease Agreement"
        },
          postLeaseAgreement?.leaseAgreementId, leaseData as any).then((response) => {
            if (response?.data?.success) {
               PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null)
              fetchData()
              getTenantsData()
              setSignLeaseAgreement(false)
            }
          }).catch((err) => { console.error("API error for lease agreement:", JSON.stringify(err)); });
      // }
    }
  }
  const renderHeader = (subHeaderName:string = "", isIcon:boolean = true) => {
    return (
      <>
        <OrganizationNameHeader
          OrgName={OrgDetail?.name}
          OrgImg={OrgDetail?.logoImageBase64 !== "" ? `data:image/*;base64,${OrgDetail?.logoImageBase64}` : null}
          SubHeaderName={subHeaderName || ""}
          element={isIcon && <>
            <div className="onboardtopbar__right ">
              <div className="onboardtopbar__chat-btn ">
               <ActionMenu
                menuItems={[
                  {
                    label: "Log Out",
                    icon: GetImages.logout,
                    action: () => { logoutFunction() },
                  },
                  {
                    label: theme === "light" ? "Dark Mode" : "Light Mode",
                    icon: theme === "light" ? <Moon size={16} /> : <Sun size={16} />,
                    action: () => { toggleTheme() },
                  }
                ]}
                trigger={
                  <Menu size={20} color={theme === "light" ? "#111928" : "#f9fafb"} />
                }
              />
              </div>
             
            </div>
          </>}
        />
        <div className="organization-unit-card" style={{
            ...(isPrint && {
            display: "block",
            marginBottom: "10px",
            width: "100%",
            paddingLeft: "0px",
            paddingRight: "0px"
            })
        }}>
          <UnitCardItem
            className="no-side-margin"
            key={1}
            listingData={unit}
            IsFooter={true}
            showConfirmation={undefined}
            setShowConfirmation={undefined}
            handleDeleteUnit={undefined}
            tenantInfo={{
              firstName: leaseApplication?.firstName || formData?.BasicDetails?.firstName,
              lastName: leaseApplication?.lastName || formData?.BasicDetails?.lastName,   // make sure your data has this field
              email: leaseApplication?.email || formData?.BasicDetails?.email,
              phoneNumber: leaseApplication?.formatted?.PhoneNumber || formData?.BasicDetails?.phoneNumber
            }}
            onEditUnit={undefined} // Pass onEditUnit to UnitCardItem
            isNotLink={true}
          />
        </div>
      </>
    )
  }

  useEffect(() => {
    clearErrors()
  }, [])

  const safeParse = (val?: string | null) => {
    try {
      if (val == null) return null;
      if (typeof val === "object") return val;
      return JSON.parse(val);
    } catch {
      return null;
    }
  };

  const isStepCompleted = (stepKey: string): boolean => {
    if (stepKey === "ApplicationFees") {
    return Boolean(safeParse(leaseApplication?.dataSections?.ApplicationFees)?.isPaid);
  }
    if (!leaseApplication?.dataSections) return false;
    const rawData = leaseApplication.dataSections[stepKey as keyof typeof leaseApplication.dataSections];
    const stepData = safeParse(rawData as any);
    if (!stepData) return false;
    if (Array.isArray(stepData)) {
      return stepData.length > 0;
    }
    if (typeof stepData === "object") {
      return Object.values(stepData).some(
        (value) => value !== "" && value !== undefined && value !== null
      );
    }
    return false;
  };

  const stepLabels: Record<string, string> = {
    CurrentAddress: "Current Address",
    RentIncomeCheck: "Rent Pay Information",
    CreditCheck: "Credit Check",
    EmploymentHistory: "Employment History",
    References: "References",
    Questionnaires: "Questionnaire",
    Signature: "Signature",
    ApplicationFees: "Application Fees",
  };

  const templateHas = new Set(
    template?.leaseApplicationTemplateSections
      ? Object.keys(template.leaseApplicationTemplateSections)
      : []
  );

  const leaseApplicationSteps = Object.keys(stepLabels).filter((stepKey) => templateHas.has(stepKey))
    .map((stepKey) => ({ label: stepLabels[stepKey] ?? stepKey, completed: isStepCompleted(stepKey) }));

  const completedCount = leaseApplicationSteps.filter((s) => s.completed).length;
  const totalSteps = leaseApplicationSteps.length;
  const progress = totalSteps > 0 ? Math.round((completedCount / totalSteps) * 100) : 0;

  const withDrawApplication = () => {
    apiHelper(LeaseApplicationService.putApiLeaseApplicationReivew, {
      successMessage: "WithDraw Application successfully",
      failureMessage: "Unable to WithDraw Application", showNotification: true
    }, leaseApplication?.id, leaseApplicationreview).then((res) => {
      if (res?.data?.success) { setWithdraw(false); setlogout(true) }
    }).catch((error) => { })
  }

  const logoutFunction = () => {
    PubSub.publish(TopicsEnum.Logout.toString(), {
      message: "Successfully logged out",
      type: NotificationType.Success
    });
    LoginService.putApiLoginLogout()
      .then((res) => {
        sessionStorage.clear();
        // setIsLogin(false);
        setTimeout(() => {
          navigate(URLS.HOME, {
            state: {
              isComingFromLogout: true,
            },
          });
          // navigate(URLS.HOME);
        }, 1000);
      })
      .catch((error) => { });
  };

  useEffect(() => {
    if ( postLeaseAgreement.leaseAgreementStatusTypeId == LeaseAgreementStatusTypesEnum.Signed) {
      sessionStorage.setItem("tenantInfo", JSON.stringify({ tenantId: userData.id,
    unitId: userData.unitId,
    propertyId: userData.propertyId,
    leaseApplicationId: userData.currentLeaseApplicationId}));
      navigate("/")
    }
  }, [postLeaseAgreement.leaseAgreementStatusTypeId])

  const stepImages = {
  [OnboardingStepsEnums.Signature]: GetImages.Signature,
  [OnboardingStepsEnums.CurrentAddress]: GetImages.CurrentAddress,
  [OnboardingStepsEnums.CreditCheck]: GetImages.CreditCheck,
  [OnboardingStepsEnums.RentIncomeCheck]: GetImages.RentIncomeCheck,
  [OnboardingStepsEnums.EmploymentHistory]: GetImages.EmploymentHistory,
  [OnboardingStepsEnums.References]: GetImages.References,
  [OnboardingStepsEnums.Questionnaires]: GetImages.Questionnaires,
};

  // TenantService.ConvertFromEntity computes a dedicated LeaseAgreementStatusTypesEnum.MovedOut status
  // (TenantService.cs:227-231) driven directly off a completed TenantMove(MoveOut) record -- the
  // authoritative "has this tenant moved out" signal, unlike Tenant.CurrentLeaseAgreementId (which
  // ActiveLeaseAgreement's fallback keeps pointing at the same lease even after it ends) or EndDate
  // (which can equal "today", not strictly in the past, right at the moment move-out completes). The
  // per-application `status` computed above (from leaseAgreementStatusTypeId) never reverts once a
  // lease is Signed, so relying on it alone keeps showing the old signed-lease view forever after
  // move-out -- this catches that case instead. Derived directly from state (not stored in its own
  // state+effect) so there's no extra render where it's stale.
  const movedOut = userData?.leaseAgreementStatus === LeaseAgreementStatusTypesEnum.MovedOut;
  const effectiveGoodbyeReason = goodbyeReason ?? (movedOut ? "movedOut" : null);

  if (effectiveGoodbyeReason) {
    const copy = GOODBYE_SCREEN_COPY[effectiveGoodbyeReason];
    return (
      <GoodbyePage
        name={tenantObject?.firstName}
        message={copy.message}
        subtext={copy.subtext}
        icon={copy.icon}
        title={copy.title}
        animateIcon={copy.animateIcon}
        onLogout={() => {
          sessionStorage.clear();
          navigate(URLS.LOGIN, { replace: true });
        }}
      />
    );
  }

  if (isInitialDataLoading) {
    return <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <SimpleSpinner />
    </div>;
  }

  return (<>
    {/* tenantObject (parsed), not tenantData (the raw sessionStorage string) -- sessionStorage.getItem
        returns the literal string "null" for a deleted tenant's fresh login (see login.service.ts),
        which is a non-null, truthy string and would never equal `null` here, wrongly falling through
        to the "resume onboarding" branch below instead of the invitation-code screen. */}
    {(codeExpired && tenantObject == null) ? <FullLoginScreen /> :
      (!codeExpired && tenantObject == null) ?
        <>  {!isPrint && renderHeader()}
          <div className="sectionStepContainer">
            <StepOne
              formData={formData?.BasicDetails}
              setFormData={setFormData}
              errors={errors?.BasicDetails}
              docsArr={docsArr}
              setDocsArr={setDocsArr}
              isEdit={isEdit}
              leaseApplicationid={leaseApplicationid}
              leaseApplicationToken={leaseApplicationToken}
              tenantId={userData?.id}
            />
          </div>

        </> : <> <div className={`outer-container`} id="FinalStep">
          <>{!isPrint && renderHeader()}</>
          {status == "landlordSignaturePending" || status == "signed" || status == "tenantSignaturePending" || status == "agreementPaymentPending" ?
            <div className="tenantOnboardingContainer">
              <div className="tenantOnboardingLeft">
                <div className="d-flex flex-column gap-1">
                  <div className="d-flex justify-content-between">
                  <p className={TextCss.black.heading_700_16}>Lease Application</p>
                  <img alt="application chevron" src={GetImages.BlackChevronDown} />
                  </div>
                  <div className="separator-horizontal"/>                  
                  <div className="BackgroundlightBlue p-2 rounded d-flex align-items-start">
                  <p className={TextCss.black.heading_700_16}>Lease Agreement</p>
                  </div>
                  </div>
                {/* <StepProgress title="Lease Application" steps={[{ label: "Lease Agreement", completed: true }]} progress={100} /> */}
              </div>
              <div className="tenantOnboardingRight">
                <StatusHeader status={status} onActionClick={handleActionClick} />
                <div className="LeaseAgreementContainer sectionStepContainer">
                  <ShowLeaseAgreement
                    leaseApplicationId={leaseApplicationid}
                    role="tenant"
                    isPreview={false}
                    userData={userData}
                    postLeaseAgreement={postLeaseAgreement}
                    setPostLeaseAgreement={setPostLeaseAgreement}
                    onCancel={() => setSignLeaseAgreement(false)}
                    onClick={() => setShowSignAgreeConfirm(true)}
                    buttonName={"Sign and Sent"}
                    selectedTemplateid={undefined}
                    selectedTemplates={undefined}
                  />
                </div>
              </div>
            </div>
            : <>
              <div className="tenantOnboardingContainer">
                <div className="tenantOnboardingLeft">
                  <StepProgress title="Lease Application" steps={leaseApplicationSteps} progress={progress} />
                </div>
                <div className="tenantOnboardingRight">
                  {((steps[currentStepIndex] === OnboardingStepsEnums.Signature) || showApp) && (
                    <StatusHeader
                      status={status}
                      onActionClick={handleActionClick} />)}
                  <div className="onboardBoxContainer">
                    {(!showApp && !(steps[currentStepIndex] === OnboardingStepsEnums.Signature)) && (
                      <>
                        <SectionHeader headerImg={stepImages[steps[currentStepIndex]]} title={steps[currentStepIndex]?.replace(/([A-Z])/g, ' $1').trim()} />
                        <div className="sectionStepContainer">
                          <div className="sectionStep">
                            {renderSteps({
                              currentStepIndex,
                              setpreStepIndex,
                              errors,
                              formData,
                              setFormData,
                              steps,
                              isEditClick,
                              isEdit,
                              docsArr,
                              setDocsArr,
                              leaseApplicationid,                              
                              goToApplicationView,
                              leaseApplicationTemplateSections: template?.leaseApplicationTemplateSections,
                              isPrint,
                              tenantId:userData?.id,
                            })}
                          </div>
                        </div>
                        <div className="onboardingfooter">
                          <Footer
                            goPrevStep={goPrevStep}
                            currentStepIndex={currentStepIndex}
                            stepFivePart2={stepFivePart2}
                            steps={steps} stepsCount={steps.length - 1}
                            handleSubmit={handleSubmit}
                            loading={loading}
                          />
                        </div>
                      </>
                    )}
                    {((!showApp) && steps[currentStepIndex] === OnboardingStepsEnums.Signature) && (
                      <div data-theme={isPrint ? "light" : undefined} className={`${isPrint ? "" : "sectionStepContainer"}`} ref={contentRef}>
                        {isPrint && <div className="print-gap">{renderHeader("Lease Application",false)}</div>}
                        <BoardingReview
                          steps={steps}
                          setFormData={setFormData}
                          formData={formData?.Signature}
                          editable={isPrint ? false : true}
                          isPreview={isPrint}
                          leaseApplicationId={leaseApplicationid}
                          isEditClick={isEditClick}
                          postData={undefined}
                          handleSubmit={handleSubmit}
                        /></div>)}

                    {showApp && (
                      <section data-theme={isPrint ? "light" : undefined} ref={contentRef} className={`${isPrint ? "d-flex flex-column sectionStepContainer gap-0 " : "sectionStepContainer"} `}
                      >
                        {isPrint && <div className="print-gap">{renderHeader("Lease Application", false)}</div>}
                        <BoardingReview
                          editable={false}
                          leaseApplicationId={leaseApplicationid}
                          isEditClick={isEditClick}
                          postData={undefined}
                          formData={formData?.Signature}
                          setFormData={setFormData}
                          steps={undefined}
                          getTenantsData={getTenantsData}
                          isPreview={true}
                        />
                      </section>)}
                  </div>
                </div>
              </div>
            </>}
        </div>
        </>}

    {withdraw && (
      <CommonConfirmation show={true} onConfirm={withDrawApplication}
        onClose={() => { setWithdraw(false); setleaseApplicationreview(prev => ({ ...prev, tenantNotes: "" })) }}
        heading="Withdraw Application"
        subHeading="Are you sure you want to withdraw your application ?"
        confirmLabel="Yes Withdraw"
        cancelLabel="Cancel"
        Element={<><label className="normal_text">Please let us know why you want to withdraw (optional)</label>
          <CustomInputTextArea
            name="answer"
            placeholder="Add your reason"
            required
            isFormControl
            value={leaseApplicationreview?.tenantNotes}
            onChange={(e) => setleaseApplicationreview(prev => ({ ...prev, tenantNotes: e.target.value }))}
            isError={false}
            errorMessages="reason required "
            myClassName="normal_text black mt-2"
            rows={4}
          />
        </>}
      />)}
      {showSignAgreeConfirm && (
  <ConfirmationPopup
    isOpen={true}
    title="Confirm Signature"
    message="Are you sure you want to Sign Agreement?"
    primaryButtonLabel="No"
    secondaryButtonLabel="Yes"
    onPrimaryAction={() => setShowSignAgreeConfirm(false)}
    onSecondaryAction={() => {
      setShowSignAgreeConfirm(false);
      SignLeaseAgreement();   // <-- your function will be called here
    }}
    onClose={() => setShowSignAgreeConfirm(false)}
    isPrimaryAction={false}
    isPrimaryDestructive={false}
  />
)}
    {logout && (
      <CommonConfirmation
        show={true}
        onConfirm={logoutFunction}
        // onClose={() => { setlogout(false); setleaseApplicationreview(prev => ({ ...prev, tenantNotes: "" })) }}
        onClose={undefined}
        heading={undefined}
        subHeading={undefined}
        confirmLabel="Logout"
        cancelLabel={null}
        Element={<div className="d-flex flex-column align-items-center justify-content-center gap-3">
          <img alt="withdraw" src={GetImages.success} className="Icon60" />
          <p className="main_heading">You have successfully withdrawn</p>
        </div>}
        buttonCenter={true} />)}
    {isProcessingSignature && (
      <LoaderOverlay message="Finalizing your signature..." />
    )}
    {isDownloadingApplication && (
      <LoaderOverlay message="Downloading application..." />
    )}
  </>
  );
};
export default TenantOnboard;